import { enumScaleSortOption } from '@rematter/frontend-lib-api-client';

import { scalesListQueryAtom } from '../_graphql/queryScalesList';

export const $remoteScales = scalesListQueryAtom(() => ({
  variables: {
    sorting: [enumScaleSortOption.NameAsc],
  },
}));
